module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DefaultLayout', [_c('div', {
    staticClass: "max-w-screen-3xl h-32 w-full rounded-lg cursor-pointer relative group",
    on: {
      "click": _vm.goToBannerTab
    }
  }, [_c('img', {
    staticClass: "w-full h-32 object-cover select-none",
    attrs: {
      "src": _vm.banner_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "opacity-0 font-manrope group-hover:opacity-50 duration-300 absolute left-0 bottom-0 right-0 h-6 z-10 flex justify-center items-center bg-gray-50 text-gray-800"
  }, [_vm._v("\n      Change Banner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "max-w-screen-3xl px-6 py-3.5"
  }, [_c('div', {
    staticClass: "flex justify-between pb-4"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold text-gray-800 font-manrope"
  }, [_vm._v("Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white text-sm cursor-default rounded border border-gray-200"
  }, [_c('div', {
    staticClass: "flex h-10 -space-x-2"
  }, _vm._l((_vm.tabs), function(selectedTab, index) {
    return _c('button', {
      key: index,
      staticClass: "text-sm text-gray-700 cursor-pointer border-0 px-5",
      class: _vm.isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid border-b border-primary'] : [],
      on: {
        "click": function($event) {
          selectedTab.href ? _vm.goToExternalLink(selectedTab.href) : _vm.goToTab(selectedTab.routeName)
        }
      }
    }, [_vm._v("\n          " + _vm._s(selectedTab.title) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "border-b border-gray-200 border-solid"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-4"
  }, [_c('transition', [_c('router-view')], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f9b33d7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/settings.vue
// module id = 1033
// module chunks = 61